import type { RefObject } from 'react';

import type { EmailTemplate } from '../../../pages/email-templates/api/useEmailTemplate';

import Button from '../Button';
import Text from '../Text';
import { t } from '../../i18n/langue';

/**
 * L'étape de relecture avant envoi d'un modèle d'e-mail — calquée sur
 * `EtapeVerificationModele.tsx` (WhatsApp, audit 2026-09-23). Un template part
 * sans retour possible : on montre son nom et le sujet exact avant de l'envoyer.
 *
 * Pas d'aperçu du corps : `translates[].html` porte le DESIGN entier du modèle
 * (mise en page comprise), pas un texte court à extraire proprement. Le nom et
 * le sujet suffisent à confirmer le bon choix, et évitent d'afficher un fragment
 * de balisage illisible.
 */
interface EtapeVerificationModeleEmailProps {
    modele: EmailTemplate;
    sujet: string;
    titreRef: RefObject<HTMLHeadingElement>;
    onEnvoyer: () => void;
    onChoisirAutre: () => void;
}

export default function EtapeVerificationModeleEmail({
    modele,
    sujet,
    titreRef,
    onEnvoyer,
    onChoisirAutre,
}: EtapeVerificationModeleEmailProps) {
    return (
        <>
            <h2 ref={titreRef} tabIndex={-1} className="mb-2 outline-none">
                <Text variante="sousTitre" as="span">
                    {t('composeur.modelesEmail.verifiez')}
                </Text>
            </h2>
            <div className="rounded-xl bg-main-bg-color p-3">
                <Text variante="petit" ton="attenue">
                    {t('composeur.modelesEmail.modele')}
                </Text>
                <p className="mb-3 text-base text-text-color">{modele.name}</p>
                <Text variante="petit" ton="attenue">
                    {t('composeur.modelesEmail.objet')}
                </Text>
                <p data-testid="sujet-modele-email" className="text-base text-text-color">
                    {sujet}
                </p>
            </div>
            <div className="mt-4 flex flex-col gap-2">
                <Button libelle={t('composeur.modelesEmail.envoyer')} pleineLargeur onPress={onEnvoyer} />
                <Button libelle={t('composeur.modelesEmail.choisirAutre')} variante="discret" pleineLargeur onPress={onChoisirAutre} />
            </div>
        </>
    );
}
